import { useEffect, useState } from "react";
import LivePl from "./LivePl/LivePl";

const fmt = require("indian-number-format");

export default function SummaryCard({
  item,
  handleSummaryCalculated,
  userType,
}) {
  const [pfdata, setPfdata] = useState([]);
  const [total, setTotal] = useState(0);

  const LivePlTotal = (id, pf) => {
    if (!Array.isArray(item.standing) || item.standing.length === 0) return;

    setPfdata((prev) => {
      const updated = [...prev];
      const index = updated.findIndex((x) => x.id === id);

      if (index === -1) {
        updated.push({ id, pf });
      } else {
        updated[index].pf = pf;
      }

      const newTotal = updated.reduce(
        (sum, entry) => sum + parseFloat(entry.pf || 0),
        0,
      );

      setTotal(newTotal);
      return updated;
    });
  };

  useEffect(() => {
    if (
      handleSummaryCalculated &&
      typeof handleSummaryCalculated === "function"
    ) {
      const upperShare = parseFloat(item.upper_sharing) || 0;
      const selfShare = parseFloat(item.self_sharing) || 0;
      const lowerShare = parseFloat(item.lower_sharing) || 0;

      const liveUpper = (parseFloat(total) * upperShare) / 100;
      const liveSelf = (parseFloat(total) * selfShare) / 100;
      const liveLower = (parseFloat(total) * lowerShare) / 100;

      const combinedUpper = parseFloat(item.upper) - liveUpper;
      const combinedSelf = parseFloat(item.self) - liveSelf;
      const combinedLower = parseFloat(item.lower) - liveLower;

      handleSummaryCalculated({
        super_id: item.super_id,
        super_username: item.super_username,
        master_id: item.master_id,
        master_username: item.master_username,
        booked: parseFloat(item.booked).toFixed(0),
        total: parseFloat(total).toFixed(0),
        net_total: parseFloat(parseFloat(item.booked) + parseFloat(total)).toFixed(0),
        upper: parseFloat(combinedUpper).toFixed(0),
        self: parseFloat(combinedSelf).toFixed(0),
        lower: parseFloat(combinedLower).toFixed(0),
        upperLive: parseFloat(liveUpper).toFixed(0) * -1,
        selfLive: parseFloat(liveSelf).toFixed(0) * -1,
        lowerLive: parseFloat(liveLower).toFixed(0) * -1,
        shares: {
          upper: upperShare,
          self: selfShare,
          lower: lowerShare,
        },
      });
    }
  }, [total]);

  const OpenEditSuper = () => {
    window.user_id = item.super_id;
    if (typeof window.openeditSuper === "function") {
      window.openeditSuper();
    }
  };

  const OpenEditMaster = () => {
    window.user_id = item.master_id;
    if (typeof window.masterModalOpen === "function") {
      window.masterModalOpen();
    }
  };

  const formatVal = (val) => fmt.format(parseFloat(Math.abs(val) || 0).toFixed(0));
  const isProfit = total > 0;

  const getCombined = (booked, shareKey) => {
    const shareValue = parseFloat(item[shareKey]) || 0;

    const livePart =
      ((Math.abs(total) * shareValue) / 100) * (total >= 0 ? 1 : -1);

    const combined = parseFloat(booked || 0) - livePart;

    return {
      value: combined,
      share: shareValue,
      color: combined >= 0 ? "buytext" : "selltext",
    };
  };

  const netBooked = parseFloat(item.booked) + parseFloat(total);

  return (
    <div
      className={`menuContainer addHight text ${userType === 1 ? "small" : ""}`}
    >
      {/* LIVE P/L LIST */}
      {Array.isArray(item.standing) &&
        item.standing.map((i) => (
          <LivePl
            key={i.id}
            item={i}
            total={item.standing.length}
            LivePlTotal={LivePlTotal}
            small={userType === 1 ? true : false}
          />
        ))}

      {/* SUPER USERNAME */}
      {userType === 1 && (
        <div
          onClick={OpenEditSuper}
          className={`menuUsername large ${userType === 1 ? "small" : ""}`}
        >
          <div className="user_id">{item.super_username}</div>
        </div>
      )}

      {/* MASTER USERNAME */}
      <div
        onClick={OpenEditMaster}
        className={`menuUsername large ${userType === 1 ? "small" : ""}`}
      >
        <div className="user_id">{item.master_username}</div>
      </div>

      {/* BOOKED */}
      <div
        className={`menuUsername large ${
          item.booked > 0 ? "buytext" : "selltext"
        } ${userType === 1 ? "small" : ""}`}
      >
        {formatVal(item.booked)}
      </div>

      <div
        className={`menuUsername large ${total > 0 ? "buytext" : "selltext"} ${userType === 1 ? "small" : ""}`}
      > 
        {formatVal(total)}
      </div>
      {/* Booked+Live = NET */}
      <div
        className={`menuUsername large ${netBooked > 0 ? "buytext" : "selltext"} ${userType === 1 ? "small" : ""}`}
      >
        {formatVal(netBooked)}
      </div>

      {/* COMBINED (Upper / Self / Lower) */}
      {[
        { key: "upper", shareKey: "upper_sharing" },
        { key: "self", shareKey: "self_sharing" },
        { key: "lower", shareKey: "lower_sharing" },
      ].map(({ key, shareKey }) => {
        const { value, share, color } = getCombined(item[key], shareKey);

        return (
          <div
            key={key}
            className={`menuName large ${color} ${
              userType === 1 ? "small" : ""
            }`}
          >
            {formatVal(value)} ({share}%)
          </div>
        );
      })}

      {/* LIVE SHARES */}
      {["upper_sharing", "self_sharing", "lower_sharing"].map((shareKey) => {
        const shareValue = parseFloat(item[shareKey]) || 0;
        const livePart = shareValue === 0 ? 0 : (total * shareValue) / 100;

        return (
          <div
            key={shareKey}
            className={`menuName large ${
              isProfit ? "selltext" : "buytext"
            } ${userType === 1 ? "small" : ""}`}
          >
            {formatVal(Math.abs(livePart))} ({shareValue}%)
          </div>
        );
      })}
    </div>
  );
}
